import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items';
import { VehicleCategoryAvailabilityModeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-availability-mode.enum';
import { DiscountConfigurationMode } from '../../../shared/modules/vehicle-categories/enums/discount-configuration-mode.enum';
import { VehicleCategoryTypeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-type.enum';
import { VehicleCategoryFeatureItemDto } from '../../../shared/modules/vehicle-category-feature-items/dtos/vehicle-category-feature-item.dto';
import { VehicleCategoryPricingItemPresetDto } from '../../../shared/modules/vehicle-category-pricing-item-presets';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { VehicleGroupSearchDto } from '../../vehicle-groups/dtos/vehicle-group-search.dto';

/**
 * Vehicle category DTO for records
 */
@CaslSubject(AppSubjectEnum.VEHICLE_CATEGORY)
export class VehicleCategoryRecordDto extends BaseDto {
  uuid!: string;
  name!: string;
  vehicleGroupId?: number | null;
  vehicleGroup?: VehicleGroupSearchDto | null;
  type!: VehicleCategoryTypeEnum;
  availabilityMode!: VehicleCategoryAvailabilityModeEnum;
  description?: string | null;
  depositPercentage?: number | null;
  depositFlatRate?: number | null;
  standardDiscountPercentage?: number | null;
  discountConfigurationMode?: DiscountConfigurationMode | null;
  excessAmount?: number | null;
  reducedExcessAmount?: number | null;
  minAgeLimit?: number | null;
  youngDriverAgeLimit?: number | null;
  maxAgeLimit?: number | null;
  seniorAgeLimit?: number | null;
  minDrivingYears?: number | null;
  featureItems?: VehicleCategoryFeatureItemDto[] | null;
  pricingTierItems?: PricingTierItemDto[] | null;
  pricingItemPresets?: VehicleCategoryPricingItemPresetDto[] | null;

  notes?: string | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
